import('./bootstrap')

export default {}